export const RecoListData = [
  {
    id: 1,
    src: '/images/브런치.png',
    alt: 'list-img',
    title: '브릿지 앤 브런치',
    rate: '4.3',
    intro: '센 강을 가로지르는 다리 밑에 기상천외한 요리사가 숨어산다?',
  },
  {
    id: 2,
    src: '/images/토스트.png',
    alt: 'list-img',
    title: '아이 러브 브래드',
    rate: '2.8',
    intro:
      '식빵이 너무 좋아 식빵 공장에 위장 취업을 한 꼬마숙녀 수지! 저는 정말 식빵이 좋다고요.',
  },
  {
    id: 3,
    src: '/images/코코볼.JPG',
    alt: 'list-img',
    title: '코코의 소원',
    rate: '5.0',
    intro:
      '허기가 질때마다 코코볼을 먹는 문수. 어느날 코코볼이 말을 걸어오는데?',
  },
  {
    id: 4,
    src: '/images/파스타.png',
    alt: 'list-img',
    title: '멜랑꼴리 인 파스타',
    rate: '2.8',
    intro:
      '우울증을 앓던 엘리는 쿠킹 클래스를 등록한다. 그 곳에서 만난 한 괴팍한 남자와의 아슬아슬한 줄다리기!',
  },
  {
    id: 5,
    src: '/images/과일.JPG',
    alt: 'list-img',
    title: '프룻 앤 문',
    rate: '3.7',
    intro:
      '과일장사를 하는 어느 노부부에게 보물과도 같은 한 아이가 찾아오는데?',
  },
  {
    id: 6,
    src: '/images/소고기.JPG',
    alt: 'list-img',
    title: '딜라이트',
    rate: '3.0',
    intro: '워싱턴의 한 축산시장에서 벌어지는 은밀한 거래. 그들은 누구인가?',
  },
  {
    id: 7,
    src: '/images/토스트.png',
    alt: 'list-img',
    title: '아이 러브 브래드',
    rate: '2.8',
    intro:
      '식빵이 너무 좋아 식빵 공장에 위장 취업을 한 꼬마숙녀 수지! 저는 정말 식빵이 좋다고요.',
  },
  {
    id: 8,
    src: '/images/파스타.png',
    alt: 'list-img',
    title: '멜랑꼴리 인 파스타',
    rate: '2.8',
    intro:
      '우울증을 앓던 엘리는 쿠킹 클래스를 등록한다. 그 곳에서 만난 한 괴팍한 남자와의 아슬아슬한 줄다리기!',
  },
  {
    id: 9,
    src: '/images/브런치.png',
    alt: 'list-img',
    title: '브릿지 앤 브런치',
    rate: '4.3',
    intro: '센 강을 가로지르는 다리 밑에 기상천외한 요리사가 숨어산다?',
  },
  {
    id: 10,
    src: '/images/코코볼.JPG',
    alt: 'list-img',
    title: '코코의 소원',
    rate: '5.0',
    intro:
      '매일같이 코코볼을 먹는 마라토너 문수. 어느날 코코볼이 말을 걸어오는데?',
  },
  {
    id: 11,
    src: '/images/과일.JPG',
    alt: 'list-img',
    title: '프룻 앤 문',
    rate: '3.7',
    intro:
      '과일장사를 하는 어느 노부부에게 보물과도 같은 한 아이가 찾아오는데?',
  },
  {
    id: 12,
    src: '/images/소고기.JPG',
    alt: 'list-img',
    title: '딜라이트',
    rate: '3.0',
    intro: '워싱턴의 한 축산시장에서 벌어지는 은밀한 거래. 그들은 누구인가?',
  },
];
